<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @openDetailDialog="openDetailDialog"
      @reload="reload"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </page-main>
    <DetailDialog
      :visible.sync="detailDialogOptions.visible"
      :title="
        $l('INDEX.dialog_title_production_order_package_detail_info') ||
          '查看修改订单包装需求信息'
      "
      :orderPackageCode="detailDialogOptions.code"
    />
  </div>
</template>
<script>
import DetailDialog from '../detail/dialog.vue'
import BaseTable from '@/mixins/base-table'
import PageMain from './main.vue'
import PageHeader from './header.vue'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, DetailDialog },
  props: {
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      detailDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .pendingOrderDemandPackageListApi({
          orderCode: this.orderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ orderPackageCode }) {
      this.detailDialogOptions = {
        visible: true,
        code: orderPackageCode,
      }
    },
  },
}
</script>
